/* @flow */
import * as React from 'react';

const StarEmpty = props => (
  <svg width={24} height={23} viewBox="0 0 24 23" fillRule="evenodd" {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#A0A3B1"
      points="12 0 15.708 7.405 24 8.6 18 14.361 19.416 22.5 12 18.655 4.584 22.5 6 14.361 0 8.6 8.292 7.405"
      fillOpacity={0}
    />
    <path
      stroke="#505FB4"
      strokeWidth={2}
      fill="none"
      d="M12,2.234 L8.952,8.321 L2.17,9.298 L7.076,14.008 L5.915,20.684 L12,17.529 L18.085,20.684 L16.924,14.008 L21.83,9.298 L15.048,8.321 L12,2.234 Z"
    />
  </svg>
);

export default StarEmpty;



// WEBPACK FOOTER //
// ./src/assets/images/icons/star-empty.js